/**
 * HorizontalRuleIcon/index.tsx
 * desc: horizontal rule formatting icon
 * note: entity icon via IconButton; defaults its tooltip + accessible name to the
 *       icon label. Renders an accessible button when given an onClick handler.
 */
import IconButton, { type IconProps } from '../IconButton/typed';
import { translate } from '../../../utilities/localization';


const HorizontalRuleIcon = ({ tooltip, ...props }: IconProps) => (
    <IconButton
        baseClassName="horizontal-rule icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.horizontalRule.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="64 64 896 896" xmlns="http://www.w3.org/2000/svg"><path d="M904 476H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"/></svg>
    </IconButton>
);


export default HorizontalRuleIcon;
